import React, { useEffect, useState } from "react";
import "./Settings.css";

const API_ROOT =
  window.location.hostname === "localhost"
    ? "http://localhost/restaurant_api"
    : "https://menu-rtl.ir/restaurant_api";

function buildUrl(path) {
  if (!path) return "";
  if (path.indexOf("http") === 0) return path;
  if (path.startsWith("/")) path = path.slice(1);
  return `${API_ROOT}/${path}`;
}

export default function Settings() {
  const [categories, setCategories] = useState([]);
  const [menu, setMenu] = useState([]);
  const [loading, setLoading] = useState(false);

  const [editingCat, setEditingCat] = useState(null);
  const [catForm, setCatForm] = useState({ name: "", name_fa: "", file: null });

  const [editingItem, setEditingItem] = useState(null);
  const [itemForm, setItemForm] = useState({
    name: "",
    name_fa: "",
    description: "",
    description_fa: "",
    price: "",
    category_id: "",
    file: null,
  });

  const loadData = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_ROOT}/menu_api.php`);
      const text = await res.text();

      if (
        text.includes("<br") ||
        text.includes("Warning") ||
        text.includes("Fatal")
      ) {
        console.error("PHP error in response:", text);
        alert("خطای PHP در سرور. فایل menu_api.php را بررسی کنید.");
        return;
      }

      const json = JSON.parse(text);
      if (json.success) {
        setCategories(json.categories || []);
        setMenu(json.menu || []);
      } else {
        alert(
          "خطا در بارگذاری داده‌ها: " +
            (json.error || json.message || "ناشناخته")
        );
      }
    } catch (err) {
      console.error("Load error:", err);
      alert("خطای شبکه یا سرور");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  /* ========== Category actions ========== */
  const submitCategory = async (e) => {
    e.preventDefault();
    const fd = new FormData();
    fd.append("action", editingCat ? "update_category" : "add_category");
    if (editingCat) fd.append("id", editingCat.id);
    fd.append("name", catForm.name);
    fd.append("name_fa", catForm.name_fa);
    if (catForm.file) fd.append("image", catForm.file);

    try {
      const res = await fetch(`${API_ROOT}/menu_api.php`, {
        method: "POST",
        body: fd,
      });
      const json = await res.json();
      if (json.success) {
        setEditingCat(null);
        setCatForm({ name: "", name_fa: "", file: null });
        loadData();
      } else {
        alert("ذخیره دسته‌بندی ناموفق بود");
      }
    } catch (err) {
      console.error(err);
      alert("خطای شبکه");
    }
  };

  const startEditCategory = (c) => {
    setEditingCat(c);
    setCatForm({ name: c.name, name_fa: c.name_fa || "", file: null });
  };

  const deleteCategory = async (id) => {
    if (!window.confirm("آیا مطمئن هستید؟")) return;
    const fd = new FormData();
    fd.append("action", "delete_category");
    fd.append("id", id);
    try {
      const res = await fetch(`${API_ROOT}/menu_api.php`, {
        method: "POST",
        body: fd,
      });
      const json = await res.json();
      if (json.success) loadData();
    } catch {
      alert("خطا");
    }
  };

  const toggleCategory = async (id, curHidden) => {
    const fd = new FormData();
    fd.append("action", "toggle_hidden");
    fd.append("target", "category");
    fd.append("id", id);
    fd.append("is_hidden", curHidden === "1" ? 0 : 1);
    try {
      const res = await fetch(`${API_ROOT}/menu_api.php`, {
        method: "POST",
        body: fd,
      });
      const json = await res.json();
      if (json.success) {
        setCategories((prev) =>
          prev.map((c) =>
            c.id === id ? { ...c, is_hidden: curHidden === "1" ? "0" : "1" } : c
          )
        );
      }
    } catch {
      alert("خطا در تغییر وضعیت");
    }
  };

  /* ========== Item actions ========== */
  const submitItem = async (e) => {
    e.preventDefault();
    if (!itemForm.category_id) return alert("لطفا دسته‌بندی را انتخاب کنید");
    const fd = new FormData();
    fd.append("action", editingItem ? "update_menu" : "add_menu");
    if (editingItem) fd.append("id", editingItem.id);
    fd.append("category_id", itemForm.category_id);
    fd.append("category", "");
    fd.append("name", itemForm.name);
    fd.append("name_fa", itemForm.name_fa);
    fd.append("description", itemForm.description);
    fd.append("description_fa", itemForm.description_fa);
    fd.append("price", itemForm.price);
    if (itemForm.file) fd.append("image", itemForm.file);

    try {
      const res = await fetch(`${API_ROOT}/menu_api.php`, {
        method: "POST",
        body: fd,
      });
      const json = await res.json();
      if (json.success) {
        setEditingItem(null);
        setItemForm({
          name: "",
          name_fa: "",
          description: "",
          description_fa: "",
          price: "",
          category_id: "",
          file: null,
        });
        loadData();
      } else alert("ذخیره آیتم ناموفق بود");
    } catch (err) {
      alert("خطای شبکه");
    }
  };

  const startEditItem = (m) => {
    setEditingItem(m);
    setItemForm({
      name: m.name,
      name_fa: m.name_fa || "",
      description: m.description || "",
      description_fa: m.description_fa || "",
      price: m.price,
      category_id: m.category_id,
      file: null,
    });
  };

  const deleteItem = async (id) => {
    if (!window.confirm("حذف شود؟")) return;
    const fd = new FormData();
    fd.append("action", "delete_menu");
    fd.append("id", id);
    try {
      const res = await fetch(`${API_ROOT}/menu_api.php`, {
        method: "POST",
        body: fd,
      });
      const json = await res.json();
      if (json.success) loadData();
    } catch {
      alert("خطا");
    }
  };

  const toggleItem = async (id, curHidden) => {
    const fd = new FormData();
    fd.append("action", "toggle_hidden");
    fd.append("target", "menu");
    fd.append("id", id);
    fd.append("is_hidden", curHidden === "1" ? 0 : 1);
    try {
      const res = await fetch(`${API_ROOT}/menu_api.php`, {
        method: "POST",
        body: fd,
      });
      const json = await res.json();
      if (json.success)
        setMenu((prev) =>
          prev.map((m) =>
            m.id === id ? { ...m, is_hidden: curHidden === "1" ? "0" : "1" } : m
          )
        );
    } catch {
      alert("خطا در تغییر وضعیت");
    }
  };

  if (loading)
    return <div className="settings-container">در حال بارگذاری...</div>;

  return (
    <div className="settings-container">
      <h2>مدیریت منو</h2>
      <div className="settings-columns">
        <form className="settings-form" onSubmit={submitCategory}>
          <h4>{editingCat ? "ویرایش دسته‌بندی" : "افزودن دسته‌بندی"}</h4>
          <input
            placeholder="نام (انگلیسی)"
            value={catForm.name}
            onChange={(e) => setCatForm({ ...catForm, name: e.target.value })}
            required
          />
          <input
            placeholder="نام (فارسی)"
            value={catForm.name_fa}
            onChange={(e) =>
              setCatForm({ ...catForm, name_fa: e.target.value })
            }
          />
          <input
            type="file"
            accept="image/*"
            onChange={(e) =>
              setCatForm({ ...catForm, file: e.target.files[0] })
            }
          />
          <div className="actions">
            <button type="submit" className="btn-submit">
              {editingCat ? "بروزرسانی" : "افزودن"}
            </button>
            {editingCat && (
              <button
                type="button"
                className="btn-cancel"
                onClick={() => {
                  setEditingCat(null);
                  setCatForm({ name: "", name_fa: "", file: null });
                }}
              >
                انصراف
              </button>
            )}
          </div>
        </form>

        <form className="settings-form" onSubmit={submitItem}>
          <h4>{editingItem ? "ویرایش آیتم" : "افزودن آیتم"}</h4>
          <input
            placeholder="نام (انگلیسی)"
            value={itemForm.name}
            onChange={(e) => setItemForm({ ...itemForm, name: e.target.value })}
            required
          />
          <input
            placeholder="نام (فارسی)"
            value={itemForm.name_fa}
            onChange={(e) =>
              setItemForm({ ...itemForm, name_fa: e.target.value })
            }
          />
          <textarea
            placeholder="توضیحات (انگلیسی)"
            value={itemForm.description}
            onChange={(e) =>
              setItemForm({ ...itemForm, description: e.target.value })
            }
          />
          <textarea
            placeholder="توضیحات (فارسی)"
            value={itemForm.description_fa}
            onChange={(e) =>
              setItemForm({ ...itemForm, description_fa: e.target.value })
            }
          />
          <input
            type="number"
            placeholder="قیمت"
            value={itemForm.price}
            onChange={(e) =>
              setItemForm({ ...itemForm, price: e.target.value })
            }
            required
          />
          <select
            value={itemForm.category_id}
            onChange={(e) =>
              setItemForm({ ...itemForm, category_id: e.target.value })
            }
            required
          >
            <option value="">انتخاب دسته‌بندی</option>
            {categories.map((c) => (
              <option key={c.id} value={c.id}>
                {c.name}
                {c.name_fa ? ` (${c.name_fa})` : ""}
              </option>
            ))}
          </select>
          <input
            type="file"
            accept="image/*"
            onChange={(e) =>
              setItemForm({ ...itemForm, file: e.target.files[0] })
            }
          />
          <div className="actions">
            <button type="submit" className="btn-submit">
              {editingItem ? "بروزرسانی" : "افزودن"}
            </button>
            {editingItem && (
              <button
                type="button"
                className="btn-cancel"
                onClick={() => {
                  setEditingItem(null);
                  setItemForm({
                    name: "",
                    name_fa: "",
                    description: "",
                    description_fa: "",
                    price: "",
                    category_id: "",
                    file: null,
                  });
                }}
              >
                انصراف
              </button>
            )}
          </div>
        </form>
      </div>

      <div className="settings-list">
        <h4>دسته‌بندی‌ها ({categories.length})</h4>
        <div className="list-grid">
          {categories.map((c) => (
            <div
              key={c.id}
              className={`list-card ${
                c.is_hidden === "1" ? "hidden-item" : ""
              }`}
            >
              <img
                src={buildUrl(c.image)}
                alt={c.name}
                onError={(e) => (e.currentTarget.style.display = "none")}
              />
              <div className="list-meta">
                <strong>{c.name}</strong>
                <small>{c.name_fa}</small>
                <div className="status-badge">
                  {c.is_hidden === "1" ? (
                    <span className="status-hidden">مخفی</span>
                  ) : (
                    <span className="status-visible">نمایش</span>
                  )}
                </div>
                <div className="list-actions">
                  <button
                    className="btn-edit"
                    onClick={() => startEditCategory(c)}
                  >
                    ✏️
                  </button>
                  <button
                    className="btn-delete"
                    onClick={() => deleteCategory(c.id)}
                  >
                    🗑️
                  </button>
                  <button
                    className={`btn-toggle ${
                      c.is_hidden === "1" ? "btn-show" : "btn-hide"
                    }`}
                    onClick={() => toggleCategory(c.id, c.is_hidden)}
                  >
                    {c.is_hidden === "1" ? "نمایش" : "مخفی"}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <h4>آیتم‌ها ({menu.length})</h4>
        <div className="list-grid">
          {menu.map((m) => (
            <div
              key={m.id}
              className={`list-card ${
                m.is_hidden === "1" ? "hidden-item" : ""
              }`}
            >
              <img
                src={buildUrl(m.image)}
                alt={m.name}
                onError={(e) =>
                  (e.currentTarget.src =
                    "https://via.placeholder.com/150?text=بدون+تصویر")
                }
              />
              <div className="list-meta">
                <strong>{m.name}</strong>
                <small>{m.name_fa}</small>
                <small className="price">
                  {Number(m.price).toLocaleString()} تومان
                </small>
                <div className="status-badge">
                  {m.is_hidden === "1" ? (
                    <span className="status-hidden">مخفی</span>
                  ) : (
                    <span className="status-visible">نمایش</span>
                  )}
                </div>
                <div className="list-actions">
                  <button className="btn-edit" onClick={() => startEditItem(m)}>
                    ✏️
                  </button>
                  <button
                    className="btn-delete"
                    onClick={() => deleteItem(m.id)}
                  >
                    🗑️
                  </button>
                  <button
                    className={`btn-toggle ${
                      m.is_hidden === "1" ? "btn-show" : "btn-hide"
                    }`}
                    onClick={() => toggleItem(m.id, m.is_hidden)}
                  >
                    {m.is_hidden === "1" ? "نمایش" : "مخفی"}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
